/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProgramVideoListResponse } from '../models/ProgramVideoListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProgramVideosService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List all videos for a program
     * @returns ProgramVideoListResponse List of program videos
     * @throws ApiError
     */
    public getProgramClipsVideos({
        id,
    }: {
        id: string,
    }): CancelablePromise<ProgramVideoListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program-clips/{id}/videos',
            path: {
                'id': id,
            },
            errors: {
                404: `Program not found`,
            },
        });
    }

    /**
     * Add a video to a program
     * @returns any Video added
     * @throws ApiError
     */
    public postProgramClipsVideos({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: {
            videoId: string;
            orderIndex?: number;
            sets?: number | null;
            reps?: string | null;
            restSeconds?: number | null;
            tempo?: string | null;
            notes?: string | null;
            role?: 'assessment' | 'exercise' | 'evaluation';
            archived?: boolean;
            exerciseId?: string | null;
        },
    }): CancelablePromise<{
        id?: string;
        programId: string;
        videoId: string;
        exerciseId?: string | null;
        orderIndex: number;
        role?: 'assessment' | 'exercise' | 'evaluation';
        archived?: boolean;
        overrideVideoId?: string | null;
        overrideOwnerId?: string | null;
        sets?: number | null;
        reps?: string | null;
        restSeconds?: number | null;
        tempo?: string | null;
        notes?: string | null;
        video?: {
            title?: string | null;
            ownerId: string;
            sourceType?: 'upload' | 'embed';
            embedProvider?: 'youtube' | 'instagram';
            embedUrl?: string | null;
            durationSeconds?: (string | number);
            createdAt?: string;
            thumbnailR2Key?: string | null;
        };
        exercise?: {
            id: string;
            ownerId: string;
            title?: string | null;
            description?: string | null;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/program-clips/{id}/videos',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Program or video not found`,
            },
        });
    }

    /**
     * Remove a video from a program
     * @returns any Video removed
     * @throws ApiError
     */
    public deleteProgramClipsVideos({
        id,
        videoId,
    }: {
        id: string,
        videoId: string,
    }): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/program-clips/{id}/videos/{videoId}',
            path: {
                'id': id,
                'videoId': videoId,
            },
            errors: {
                404: `Program or video not found`,
            },
        });
    }

    /**
     * Update dosage fields on a program video
     * @returns any Program video updated
     * @throws ApiError
     */
    public patchProgramClipsVideos({
        id,
        programVideoId,
        requestBody,
    }: {
        id: string,
        programVideoId: string,
        requestBody: {
            sets?: number | null;
            reps?: string | null;
            restSeconds?: number | null;
            tempo?: string | null;
            notes?: string | null;
            role?: 'assessment' | 'exercise' | 'evaluation';
            archived?: boolean;
            exerciseId?: string | null;
        },
    }): CancelablePromise<{
        id?: string;
        programId: string;
        videoId: string;
        exerciseId?: string | null;
        orderIndex: number;
        role?: 'assessment' | 'exercise' | 'evaluation';
        archived?: boolean;
        overrideVideoId?: string | null;
        overrideOwnerId?: string | null;
        sets?: number | null;
        reps?: string | null;
        restSeconds?: number | null;
        tempo?: string | null;
        notes?: string | null;
        video?: {
            title?: string | null;
            ownerId: string;
            sourceType?: 'upload' | 'embed';
            embedProvider?: 'youtube' | 'instagram';
            embedUrl?: string | null;
            durationSeconds?: (string | number);
            createdAt?: string;
            thumbnailR2Key?: string | null;
        };
        exercise?: {
            id: string;
            ownerId: string;
            title?: string | null;
            description?: string | null;
        };
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/program-clips/{id}/videos/{programVideoId}',
            path: {
                'id': id,
                'programVideoId': programVideoId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                404: `Program or program video not found`,
            },
        });
    }

    /**
     * Set or clear the client's own recording as the playback override
     * @returns any Program video override updated
     * @throws ApiError
     */
    public putProgramClipsProgramVideosOverride({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: {
            videoId: string | null;
        },
    }): CancelablePromise<{
        id?: string;
        programId: string;
        videoId: string;
        exerciseId?: string | null;
        orderIndex: number;
        role?: 'assessment' | 'exercise' | 'evaluation';
        archived?: boolean;
        overrideVideoId?: string | null;
        overrideOwnerId?: string | null;
        sets?: number | null;
        reps?: string | null;
        restSeconds?: number | null;
        tempo?: string | null;
        notes?: string | null;
        video?: {
            title?: string | null;
            ownerId: string;
            sourceType?: 'upload' | 'embed';
            embedProvider?: 'youtube' | 'instagram';
            embedUrl?: string | null;
            durationSeconds?: (string | number);
            createdAt?: string;
            thumbnailR2Key?: string | null;
        };
        exercise?: {
            id: string;
            ownerId: string;
            title?: string | null;
            description?: string | null;
        };
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/program-clips/program-videos/{id}/override',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                404: `Program video not found`,
            },
        });
    }

}
